import { FC } from "react";
import { CommonIconProps } from "../Icon/types";

const FileDocument: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))"
}) => {
  return (
    <svg
      className="icon-file-document"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25 19C4.25 19.6904 4.80964 20.25 5.5 20.25H10.5C11.1904 20.25 11.75 19.6904 11.75 19V14C11.75 13.3096 11.1904 12.75 10.5 12.75H5.5C4.80964 12.75 4.25 13.3096 4.25 14V19ZM2.75 14C2.75 12.4812 3.98122 11.25 5.5 11.25H10.5C12.0188 11.25 13.25 12.4812 13.25 14V19C13.25 20.5188 12.0188 21.75 10.5 21.75H5.5C3.98122 21.75 2.75 20.5188 2.75 19V14Z"
        fill={fill}
      />
      <path
        d="M9.5 14.25C9.91421 14.25 10.25 14.5858 10.25 15C10.25 15.4142 9.91421 15.75 9.5 15.75H6.5C6.08579 15.75 5.75 15.4142 5.75 15C5.75 14.5858 6.08579 14.25 6.5 14.25H9.5Z"
        fill={fill}
      />
      <path
        d="M9.5 17.25C9.91421 17.25 10.25 17.5858 10.25 18C10.25 18.4142 9.91421 18.75 9.5 18.75H6.5C6.08579 18.75 5.75 18.4142 5.75 18C5.75 17.5858 6.08579 17.25 6.5 17.25H9.5Z"
        fill={fill}
      />
      <path
        d="M4.75 9V5.5C4.75 3.70507 6.20507 2.25 8 2.25H15.1279C16.1225 2.25 17.077 2.64537 17.7803 3.34863L20.1514 5.71973C20.8546 6.42299 21.25 7.37751 21.25 8.37207V18.5C21.25 20.2949 19.7949 21.75 18 21.75H15.5C15.0858 21.75 14.75 21.4142 14.75 21C14.75 20.5858 15.0858 20.25 15.5 20.25H18C18.9665 20.25 19.75 19.4665 19.75 18.5V8.37207C19.75 7.77533 19.5128 7.20223 19.0908 6.78027L16.7197 4.40918C16.2978 3.98722 15.7247 3.75 15.1279 3.75H8C7.0335 3.75 6.25 4.5335 6.25 5.5V9C6.25 9.41421 5.91421 9.75 5.5 9.75C5.08579 9.75 4.75 9.41421 4.75 9Z"
        fill={fill}
      />
      <path
        d="M14.75 6.50018V3.02362C14.75 2.60941 15.0858 2.27362 15.5 2.27362C15.9142 2.27362 16.25 2.60941 16.25 3.02362V6.50018C16.2501 6.91431 16.5858 7.25018 17 7.25018H20.4766C20.8907 7.25025 21.2266 7.58601 21.2266 8.00018C21.2265 8.41427 20.8907 8.75011 20.4766 8.75018H17C15.7574 8.75018 14.7501 7.74274 14.75 6.50018Z"
        fill={fill}
      />
    </svg>
  );
};

export default FileDocument;
